export default {
  s: '%d Sekunden',
  smicro: '%d s',
  smid: '%d sek',

  ss: '%d Sekunden',
  ssmicro: '%d s',
  ssmid: '%d sek',

  m: '%d Minute',
  mmicro: '%d m',
  mmid: '%d min',

  mm: '%d Minuten',
  mmmicro: '%d min',
  mmmid: '%d min',

  h: '%d Stunde',
  hmicro: '%d h',
  hmid: '%d h',

  hh: '%d Stunden',
  hhmicro: '%d S',
  hhmid: '%d Stunden',

  d: '%d Tag',
  dmicro: '%d T',
  dmid: '%d Tag',

  dd: '%d Tage',
  ddmicro: '%d T',
  ddmid: '%d Tage',
};
